/**
 * Okta active-apps truncation workspace banner (POST-ARC.11a).
 *
 * @module client/utils/oktaAppsTruncationBanner
 */

/**
 * @param {unknown} auditData
 */
export function resolveOktaAppsTruncationBanner(auditData) {
  if (!auditData || typeof auditData !== "object") return null;
  const raw = /** @type {{ rawData?: { applications?: Record<string, unknown> } }} */ (auditData)
    .rawData;
  const apps = raw?.applications;
  if (!apps || typeof apps !== "object" || !apps.truncated) return null;

  const fetched =
    typeof apps.fetched_count === "number" ? apps.fetched_count : null;
  const total = typeof apps.total_count === "number" ? apps.total_count : null;
  const cap = typeof apps.fetch_cap === "number" ? apps.fetch_cap : 500;

  const coverage =
    fetched != null && total != null
      ? `${fetched} of ${total}`
      : fetched != null
        ? String(fetched)
        : "a subset of";

  return {
    tone: "amber",
    message: "Partial application coverage.",
    detail: `This tenant exceeds the assessment cap (${cap} apps). Coverage: ${coverage} active apps enumerated. Some findings may not reflect full tenant state. Increase OKTA_APPS_FETCH_CAP on the server to assess more apps.`,
  };
}
